import { render, staticRenderFns } from "./StorageSpaceShowScreen.vue?vue&type=template&id=44def737&"
import script from "./StorageSpaceShowScreen.vue?vue&type=script&lang=js&"
export * from "./StorageSpaceShowScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports